import React, { useEffect } from "react";
import { close } from "../../assets/images/icons";
import parse from "html-react-parser";
import "./modal.scss";

const MODAL_ID = "modal";

const Modal = ({
  isOpen = false,
  children,
  wrapperClassname,
  onClose = () => {},
}) => {
  const modalElem = document.getElementById(MODAL_ID);
  useEffect(() => {
    if (isOpen) {
      modalElem?.showModal();
    } else {
      modalElem?.close();
    }
  }, [isOpen]);
  return (
    <dialog
      id={MODAL_ID}
      className={`${wrapperClassname} modal`}
    >
      <div
        onClick={() => {
          onClose();
        }}
        className="close-icon"
      >
        {parse(close)}
      </div>
      {children}
    </dialog>
  );
};

export default Modal;
